const AUTH_STORAGE_KEYS = ['token', 'role', 'nickname', 'userId'];

export const recoverFromAdminAuthFailure = (status?: number) => {
    if(status !== 401 && status !== 403) {
        return false;
    }

    AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));

    if(window.location.hash !== '#/login?reason=session-expired') {
        window.location.hash = '#/login?reason=session-expired';
    }

    return true;
};

export const getLoginReasonMessage = (search: string) => {
    const reason = new URLSearchParams(search).get('reason');

    return reason === 'session-expired'
        ? '로그인이 만료되었습니다. 다시 로그인해주세요.'
        : '';
};
